module.exports = __webpack_public_path__ + "img/thumbnail_GalapagosGiantTortoise_m_normal.18801071.png";